import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With over 28 years in the financial sector and 15+ years at the C-level, how has
                the role of internal audit evolved in today’s fast-changing digital banking
                environment?
              </strong>
            </h5>

            <h5 className="text-white">
              Internal Audit is no longer seen as that reporter coming into a battlefield, once the
              battle is over, to count the dead bodies and bayonet the injured. Most IA functions
              have positioned themselves as Trusted Advisors giving insights and foresights to all
              its stakeholders. In a digital environment it becomes even more important as the risks
              are less visible and the risk landscapes evolve rapidly.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You bring expertise in both audit and cybersecurity. How should financial
                institutions integrate these functions to proactively detect and mitigate risks,
                especially in the face of rising cyber threats?
              </strong>
            </h5>
            <h5 className="text-white">
              Digital revolution has brought cybersecurity increasingly to the forefront. While the
              first line executes controls and second line helps in designing and governing these
              controls, IA as a third line has a critical role to play in assessing the design as
              well as operating effectiveness of these controls. Deep understanding of Cyber Risks
              and close collaboration with first and second lines help IA function to ensure that
              organization’s information assets are adequately protected at all times against
              external as well as internal threats.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-As Chairman of the Banking, Insurance & Finance Subgroup of UAE IAA, what key
                governance and compliance challenges are you seeing across the region—and how can
                audit leaders address them?
              </strong>
            </h5>
            <h5 className="text-white">
              With newer technologies bringing AI and Machine Learning into the forefront, the
              challenges for governing the usage of these technologies are increasing. Further, the
              evolving business models like crypto, tokenization, open banking etc not only creates
              compliance nightmares, but also increases the overall cost of compliance. Hence it is
              very important for the Internal Audit leaders to seriously think about closer
              collaboration with other control and governance functions within the organisation
              leading to initiatives like Aligned Assurance Frameworks.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You’ve mentored many professionals in audit and cybersecurity. What core
                competencies do you believe the next generation of audit leaders must develop to
                stay relevant?
              </strong>
            </h5>
            <h5 className="text-white">
              Continuous learning, close collaboration and a positive, proactive attitude are the
              essential traits to become successful in the fields of Internal Audit and Cyber
              Security.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-From your perspective as a Certified Fraud Examiner and audit executive, what best
                practices can institutions adopt to strengthen fraud detection and response
                frameworks in today’s digital-first world?
              </strong>
            </h5>
            <h5 className="text-white">
              Fraud detection and response frameworks are all limited in effectiveness if the
              organisational culture is not conducive to prevent fraud. The overall culture should
              be one that discourages wrong behavior, having zero tolerance to fraud and encourages
              whistle blowing. Early identification of incentivising wrong behavior in the name of
              business growth is a key contribution that IA can make to strengthen fraud controls
              within the organisation.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
